import { render, staticRenderFns } from "./DSCustomerFields.vue?vue&type=template&id=14945e07&"
import script from "./DSCustomerFields.vue?vue&type=script&lang=js&"
export * from "./DSCustomerFields.vue?vue&type=script&lang=js&"
import style0 from "./DSCustomerFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports